<router-outlet />
<p-toast position="top-right" />
<!-- Toast dédié au recalcul : gabarit `#headless` (et non `#message`), le SEUL qui remplace tout
     le contenu de la carte PrimeNG. Avec `#message`, PrimeNG garde son conteneur (padding + gap +
     align-items: flex-start) et son bouton de fermeture décalé hors flux, mais retire le bloc de
     texte qui portait `flex: 1 1 auto` : le contenu projeté ne prenait plus la largeur de la carte.
     On reprend donc la main sur toute la carte. Transitions alignées sur la convention maison
     (~0,18 s ease-out + petit translateY) plutôt que le translateY(100%) de PrimeNG. -->
<p-toast
  position="top-right"
  key="recompute"
  styleClass="rct-toast"
  showTransformOptions="translateY(-8px)"
  showTransitionOptions="180ms ease-out"
  hideTransformOptions="translateY(-8px)"
  hideTransitionOptions="150ms ease-in"
>
  <ng-template let-message let-closeFn="closeFn" #headless>
    <div class="rct">
      <div class="rct__row">
        @if (message.data?.state === 'running') {
          <span class="rct__ico rct__ico--run" aria-hidden="true"></span>
        } @else {
          <span class="rct__ico rct__ico--ok" aria-hidden="true">
            <app-icon name="check" [size]="18" />
          </span>
        }
        <span class="rct__txt">
          <span class="rct__title">{{ message.summary }}</span>
          <span class="rct__detail">{{ message.detail }}</span>
        </span>
        <button type="button" class="rct__close" aria-label="Fermer" (click)="closeFn($event)">
          ✕
        </button>
      </div>
      @if (message.data?.state === 'running') {
        <span class="rct__bar" aria-hidden="true"></span>
      } @else {
        <!-- Bande d'action pleine largeur, à la place qu'occupait la barre : vocabulaire de
             notification plutôt que petit bouton posé dans un coin, et zone cliquable large. -->
        <button type="button" class="rct__action" (click)="recompute.reloadNow()">
          Rafraîchir la page
          <app-icon name="chevron" [size]="16" />
        </button>
      }
    </div>
  </ng-template>
</p-toast>

<!-- Rappel du journal de version (super admin). Même gabarit `#headless` et mêmes classes `.rct`
     que le toast de recalcul : c'est la même carte, avec la même bande d'action en pied. En
     dupliquer le style sous un autre préfixe donnerait deux notifications qui divergeraient à la
     première retouche. Ce toast MÈNE au journal — un rappel qui dit seulement où aller oblige à
     retenir le chemin, ce qui est exactement ce qu'on cherche à éviter ici. -->
<p-toast
  position="top-right"
  key="journal"
  styleClass="rct-toast"
  showTransformOptions="translateY(-8px)"
  showTransitionOptions="180ms ease-out"
  hideTransformOptions="translateY(-8px)"
  hideTransitionOptions="150ms ease-in"
>
  <ng-template let-message let-closeFn="closeFn" #headless>
    <div class="rct">
      <div class="rct__row">
        <span class="rct__ico rct__ico--ok" aria-hidden="true">
          <app-icon name="clock" [size]="18" />
        </span>
        <span class="rct__txt">
          <span class="rct__title">{{ message.summary }}</span>
          <span class="rct__detail">{{ message.detail }}</span>
        </span>
        <button type="button" class="rct__close" aria-label="Fermer" (click)="closeFn($event)">
          ✕
        </button>
      </div>
      <button type="button" class="rct__action" (click)="ouvrirJournal(closeFn, $event)">
        Ouvrir le journal de version
        <app-icon name="chevron" [size]="16" />
      </button>
    </div>
  </ng-template>
</p-toast>
